import React, { Children, forwardRef, isValidElement, ReactElement, ReactNode, Ref } from 'react'

import { Spacing } from '../../enums/spacing'
import * as Styled from './styles'

export interface ComponentsGroupProps {
  centered?: boolean
  children: ReactNode
  direction?: Styled.Direction
  fitToWidth?: boolean
  merged?: boolean
  spacing?: Spacing
  wrap?: boolean
}

export const ComponentsGroup = forwardRef(
  (
    {
      centered = true,
      children,
      direction = 'row',
      fitToWidth,
      merged,
      spacing,
      wrap = true,
      ...rest
    }: ComponentsGroupProps,
    forwardedRef: Ref<HTMLUListElement>,
  ): ReactElement => (
    <Styled.ComponentsGroupList
      centered={centered}
      direction={direction}
      ref={forwardedRef}
      spacing={spacing}
      $wrap={wrap}
      {...rest}
    >
      {Children.map(
        children,
        (child) =>
          isValidElement(child) && (
            <Styled.ComponentsGroupItem fitToWidth={fitToWidth}>{child}</Styled.ComponentsGroupItem>
          ),
      )}
    </Styled.ComponentsGroupList>
  ),
)
